import { getCookie } from '@app/services'

export const isWebView = () => {
  const userAgentCookie = getCookie('userAgent')
  return userAgentCookie?.includes('com.listglobally.properstar') || false
}
